import { Group, Stack, Text } from "@mantine/core"
import { Missing } from "@tfg/ui"
import { ReactNode } from "react"

type Props = {
  label: string
  value?: string | ReactNode | null
}

export const PropertyItemInfo = ({ label, value }: Props) => (
  <Stack gap="xs" align="flex-start">
    <Group justify="space-between" w="100%" wrap="nowrap">
      <Text fz="sm" fw={400}>
        {label}
      </Text>

      {!!value && typeof value === "string" ? (
        <Text fz="sm" style={{ textAlign: "right" }} fw={600}>
          {value}
        </Text>
      ) : (
        value || <Missing />
      )}
    </Group>
  </Stack>
)
